import { stringify } from 'qs';

import { Notification } from '../../constants/apis';
import type { GetNotificationResponse, GetNotificationsOption } from '../../types/notification';
import { ApiManager, SHOW_TOAST_HEADER } from '../axios-config';

export const getNotifications = async (token: string, options?: GetNotificationsOption) => {
  return await ApiManager.get<GetNotificationResponse>(Notification, {
    params: {
      ...(options?.category && {
        Category: options.category,
      }),
      ...(options?.isRead !== undefined && { isRead: options?.isRead }),
      PageNumber: options?.pageNumber || 1,
      PageSize: options?.pageSize || 10,
    },
    paramsSerializer: (params) => {
      return stringify(params);
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const getNotificationsCount = async (token: string) => {
  return await ApiManager.get(`${Notification}/count`, {
    headers: {
      Authorization: `Bearer ${token}`,
      [SHOW_TOAST_HEADER]: false,
    },
  });
};

export const readAllNotifications = async (token: string) => {
  return await ApiManager.put(
    `${Notification}/mark-as-read`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
        [SHOW_TOAST_HEADER]: false,
      },
    },
  );
};

export const readNotification = async (id: string, token: string) => {
  return await ApiManager.put(
    `${Notification}/${id}/mark-as-read`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
        [SHOW_TOAST_HEADER]: false,
      },
    },
  );
};
